module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_about-fa99c2c77194b984f5455fd74e574fe3.png";